/* global google */
import $ from 'jquery';

export const timeout = {};
export const initMap = ($divs, opt) => {
    var $maps = $divs || $('.map');

    $maps.each(function() {
        var $el = $(this),
            map,
            marker,
            lat = $el.data('lat') ? $el.data('lat') : -37.859489,
            lng = $el.data('lng') ? $el.data('lng') : 144.984473,
            options = {
                map: {
                    zoomControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    scrollwheel: false,
                    zoom: 17,
                },
                destination: {
                    x: lat,
                    y: lng,
                },
                marker: {
                    //icon: 'assets/img/ic-map.png',
                    optimized: false,
                    zIndex: 100,
                    icon: {
                        scaledSize: new google.maps.Size(50, 50),
                    },
                },
            };

        if ($el.data('pin')) {
            options.marker.icon.url = $el.data('pin');
        }

        // extend options
        $.extend(options, opt);

        if (!$el.length) {
            return;
        }

        // center
        options.map.center = new google.maps.LatLng(
            options.destination.x,
            options.destination.y
        );
        options.marker.position = options.map.center;

        // iniate
        map = new google.maps.Map($el[0], options.map);
        marker = new google.maps.Marker(
            $.extend(true, options.marker, { map: map })
        );

        // styles
        map.set('styles', [
            {
                stylers: [
                    {
                        saturation: -100,
                    },
                    {
                        lightness: -8,
                    },
                    {
                        gamma: 1.18,
                    },
                ],
            },
        ]);

        // resize window/map
        google.maps.event.addDomListener(window, 'resize', function() {
            var center = map.getCenter();
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
        });

        // set map
        $el = map;
    });
};
export const binds = () => {
    timeout.interval = setInterval(function() {
        if (typeof google !== 'undefined') {
            clearInterval(timeout.interval);
            initMap();
        }
    }, 500);
};
